import { TMember } from '../components/MembersWizard/types';

interface BoostReward {
  affiliateId: number;
  boostRewardMetadata?: {
    pfaOrderId?: string;
  };
}

interface BoostData {
  boostRewardsForAffiliate?: BoostReward[];
}

export const extractPFAOrderIds = (
  boostDataArray: BoostData[] | null,
  selectedMembers: readonly TMember[] | null
): string[] => {
  if (!boostDataArray || !selectedMembers?.length) {
    return [];
  }

  // Get selected member affiliate IDs for quick lookup
  const selectedAffiliateIds = new Set(selectedMembers.map((member) => member.affiliateId));

  // Extract PFA order IDs from all boost data items
  const allPfaOrderIds: string[] = [];

  boostDataArray.forEach((boostData) => {
    if (boostData?.boostRewardsForAffiliate) {
      const pfaOrderIds = boostData.boostRewardsForAffiliate
        .filter((reward) => selectedAffiliateIds.has(reward.affiliateId))
        .map((reward) => reward.boostRewardMetadata?.pfaOrderId)
        .filter((id): id is string => !!id);

      allPfaOrderIds.push(...pfaOrderIds);
    }
  });

  return allPfaOrderIds;
};

// Hook to use the function
export const useGetPFAOrderIds = (
  boostDataArray: BoostData[] | null,
  selectedMembers: readonly TMember[] | null
) => {
  const pfaOrderIds = extractPFAOrderIds(boostDataArray, selectedMembers);

  return {
    pfaOrderIds,
    loading: false,
    error: null
  };
};
